import LayoutApp from "@lhd/components/CloneApp/LayoutApp";
import { convertDataToDataForm } from "@lhd/components/CloneApp/untils";
import { AppRecordV2, AppV2, AppSelectionList } from "@lhd/types";
import { Form } from "antd";
import { Styles } from "./styled";

interface IProps {
  dataApp: AppV2;
  appRecord: AppRecordV2;
  selectionDataList?: AppSelectionList;
}

const FinancialReportsPDF = ({
  dataApp,
  appRecord,
  selectionDataList,
}: IProps) => {
  const [form] = Form.useForm();
  const appType = dataApp?.app_type;

  if (appRecord) {
    const result = convertDataToDataForm(
      dataApp?.app_parts || [],
      appRecord,
      true,
    );
    form.setFieldsValue(result);
  }

  return (
    <Styles>
      <table className="pdf-print-table">
        <thead>
          <tr>
            <td>
              <div className="pdf-print-header-space" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div
                style={{
                  transform: `scale(1)`,
                  transformOrigin: "top left",
                  width: `100%`,
                }}
              >
                <Form form={form} disabled>
                  <LayoutApp
                    form={form}
                    dataApp={dataApp}
                    appRecord={appRecord}
                    appType={appType}
                    isEditPage={true}
                    isEditing={false}
                    isPDF={true}
                    selectionDataList={selectionDataList}
                  />
                </Form>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Styles>
  );
};

export default FinancialReportsPDF;
